module.exports = __webpack_public_path__ + "static/media/Covid.d7265326.png";